export default __webpack_public_path__ + "static/media/fintropolis_logo.f6ccb43a.png";